import { ChartSnapshot } from 'features/spectrumChart/types';
import { useSnapshot } from 'features/snapshots/api/getSnapshot';
import { useEffect, useState } from 'react';
import { Snapshot, TraceHistory, TraceHistorySample } from 'types';

interface Props {
  snapshotId: number;
  staticSnapshot: TraceHistory | TraceHistorySample | null | undefined;
}

const defaultSnapshot: ChartSnapshot = {
  id: -1,
  name: 'No Active Snapshot',
  center: '1.5 GHZ',
  span: '300 MHZ',
  reference: -30,
  scale: 10,
  lo: '0 MHZ',
  lo_mode: 0,
  monitors: [],
  markers: [],
  masks: [],
  thresholds: [],
};

export const useFormatSnapshot = ({ snapshotId, staticSnapshot }: Props) => {
  const [snapshot, setSnapshot] = useState<Snapshot | ChartSnapshot>(
    defaultSnapshot
  );
  let { data: selectedSnapshot } = useSnapshot({ snapshotId });

  useEffect(() => {
    if (staticSnapshot && selectedSnapshot) {
      setSnapshot({
        ...selectedSnapshot,
        center: staticSnapshot.center,
        span: staticSnapshot.span,
        reference: staticSnapshot.reference,
        lo: staticSnapshot.lo,
        lo_mode: staticSnapshot.lo_mode,
      });
    } else {
      if (selectedSnapshot) setSnapshot(selectedSnapshot);
      else setSnapshot(defaultSnapshot);
    }
  }, [selectedSnapshot, staticSnapshot]);

  return snapshot;
};
